import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegistrationValidator } from '../../users/user-form/user-form-tab-common/registerValidator';
import { ApiService } from '../../../services/api.service';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['../login.component.scss', './change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
    @Input() userID: number;
    @Output() passwordChanged = new EventEmitter<void>();

    changePasswordForm: FormGroup;
    submitted = false;
    errorMessage = '';
    fieldTextType = false;

    constructor(
        private formBuilder: FormBuilder,
        private api$: ApiService,
        private authService: AuthService,
    ) {}

    ngOnInit() {
      this.changePasswordForm = this.formBuilder.group({
        NewPassword: ['', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-!@#$%^&]).{8,}')]],
        PasswordRepeat: ['', Validators.required],
      }, {
        validator: RegistrationValidator.validate.bind(this)
      });
    }

    get cpf() {
      return this.changePasswordForm.controls;
    }

    toggleFieldTextType() {
      this.fieldTextType = !this.fieldTextType;
    }

    generateNewPassword() {
      const newPass = this.authService.generatePassword(8);
      this.changePasswordForm.get('NewPassword').setValue(newPass);
      this.changePasswordForm.get('PasswordRepeat').setValue(newPass);
      alert(newPass);
    }

    onSubmit() {
      this.submitted = true;
      this.errorMessage = '';
      if (this.changePasswordForm.invalid) {
        return;
      }
      const formData = new FormData();
      formData.append('NewPassword', this.changePasswordForm.value.NewPassword);
      formData.append('PasswordRepeat', this.changePasswordForm.value.PasswordRepeat);
      this.api$.changePassword(formData).subscribe(data => {
        if (data.success === true) {
          this.passwordChanged.emit();
        } else {
          this.errorMessage = data.data?.message || 'Error changing password';
        }
      });
    }
}
